import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

const LeonardoAISection = () => {
  return (
    <section className="py-16 bg-background">
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          <div className="space-y-2">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl">Leonardo AI</h2>
            <p className="max-w-[900px] text-slate-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-slate-400">
              Plataforma de criação de imagens com IA de última geração
            </p>
          </div>
        </div>
        <div className="mx-auto grid max-w-5xl items-center gap-6 py-12 lg:grid-cols-2 lg:gap-12">
          <div className="mx-auto w-full max-w-[500px] rounded-lg border bg-background p-2 shadow-xl order-2 lg:order-1">
            <Card>
              <CardContent className="p-6">
                <div className="aspect-video overflow-hidden rounded-lg bg-slate-100 dark:bg-slate-800">
                  <img
                    alt="Leonardo AI Demo"
                    className="object-cover w-full h-full"
                    src="https://images.unsplash.com/photo-1675271591211-728bc2c85320?q=80&w=1000&auto=format&fit=crop"
                    width={500}
                    height={280}
                  />
                </div>
                <div className="mt-4 grid gap-2">
                  <h4 className="font-semibold">Criação de arte digital</h4>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    Gere ilustrações, conceitos artísticos e designs com qualidade profissional.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
          <div className="flex flex-col justify-center space-y-4 order-1 lg:order-2">
            <div className="space-y-2">
              <h3 className="text-2xl font-bold tracking-tighter sm:text-3xl">
                Potencialize sua criatividade
              </h3>
              <p className="max-w-[600px] text-slate-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-slate-400">
                Leonardo AI oferece ferramentas avançadas para artistas, designers e criadores de conteúdo gerarem imagens de alta qualidade com inteligência artificial.
              </p>
            </div>
            <div className="flex flex-col gap-2 min-[400px]:flex-row">
              <Button className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-8 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" onClick={() => window.open('https://leonardo.ai/', '_blank')}>
                Experimentar Leonardo AI
              </Button>
              <Button
                variant="outline"
                className="inline-flex h-10 items-center justify-center rounded-md border border-input bg-background px-8 text-sm font-medium shadow-sm transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
                onClick={() => window.open('https://leonardo.ai/', '_blank')}
              >
                Ver galeria
              </Button>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 py-8">
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">Modelos avançados</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Acesso a diversos modelos de IA treinados para diferentes estilos e finalidades.
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">Comunidade criativa</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Compartilhe suas criações e inspire-se com trabalhos de outros artistas.
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">Ferramentas profissionais</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Recursos avançados para edição, refinamento e personalização das imagens geradas.
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="p-6 space-y-2">
              <h4 className="font-semibold">API robusta</h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Integre a geração de imagens com IA em seus próprios aplicativos e fluxos de trabalho.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default LeonardoAISection;